// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ql-1";
export var stateContainer = "_ql-0";